<script setup>
import { ref, onMounted } from 'vue';
import { useStore } from 'vuex';
import SideNav from "./components/SideNav.vue";
import SideNavItem from "./components/SideNavItem.vue";
import Preloader from '@/components/Preloader.vue';
import api from '@/services/api';

const store = useStore();
const data = ref({
  user: null,
  roles: null,
  permissions: null,
  application: null,
  applications: null
});

const isLoading = ref(true);
const error = ref(null);

const loadData = async () => {
  try {
    console.log('📋 [Settings] Cargando datos del usuario...');
    const response = await api.get(`/user`);
    const userData = response.data.user;
    const appData = response.data.application;

    console.log('📋 [Settings] Datos del usuario recibidos:', userData);
    console.log('📋 [Settings] Datos de aplicación recibidos:', appData);

    // Cargar suscripción
    console.log('📋 [Settings] Cargando información de suscripción...');
    try {
      await store.dispatch('subscription/fetchEffectiveSubscription');
      console.log('✅ [Settings] Suscripción cargada');
    } catch (subError) {
      console.error('❌ [Settings] Error cargando suscripción:', subError);
    }

    data.value.user = {
      id: userData.id,
      application_id: userData.application_id,
      name: userData.name,
      email: userData.email,
      photo_url: userData.photo_url,
      email_verified_at: userData.email_verified_at,
      created_at: userData.created_at,
      updated_at: userData.updated_at,
      deleted_at: userData.deleted_at,
      doctor: userData.doctor
    };

    data.value.application = {
      id: appData.id,
      name: appData.name,
      description: appData.description,
      subscription: appData.subscription,
      active: appData.active,
      created_at: appData.created_at,
      updated_at: appData.updated_at
    };

    data.value.applications = Array.isArray(userData.applications)
      ? userData.applications.map(app => ({
        id: app.id,
        name: app.name,
        description: app.description,
        active: app.active,
        clinical_history: app.clinical_history,
        created_at: app.created_at,
        updated_at: app.updated_at,
        deleted_at: app.deleted_at,
        subscription: app.subscription,
        pivot: app.pivot
      }))
      : [];

    // Como roles ya viene como array de strings:
    data.value.roles = response.data.roles || [];

    // Y permissions viene como array simple:
    data.value.permissions = response.data.permissions || [];
  } catch (err) {
    console.error('Error al cargar los datos del usuario logeado:', err);
    error.value = 'Error al cargar los datos del usuario.';
  } finally {
    isLoading.value = false;
  }
};

onMounted(() => {
  loadData();
});

</script>

<template>
  <div class="container-fluid">
    <div class="row mb-5">
      <div class="col-lg-3">
        <side-nav />
      </div>
      <div class="col-lg-9 mt-lg-0 mt-4">
        <SideNavItem v-if="!isLoading && !error" :data="data" :roles="data.roles" :permissions="data.permissions" />
        
        <!-- Loader con estilo de card -->
        <div v-else-if="isLoading" class="card">
          <div class="card-body text-center py-5">
            <Preloader message="Cargando datos del usuario..." />
          </div>
        </div>
        
        <div v-else class="card">
          <div class="card-body">
            <p class="text-danger mb-0">{{ error }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
